import { render } from "./ApprovalFeedbackScreen.vue?vue&type=template&id=9aeb22de"
import script from "./ApprovalFeedbackScreen.vue?vue&type=script&lang=js"
export * from "./ApprovalFeedbackScreen.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__